import { ChangeDetectionStrategy, Component, computed, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { PrimeIcons } from 'primeng/api';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    selector: 'app-seletor-icone',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogoPadraoDirective, FormsModule, DialogModule, InputTextModule, TooltipModule],
    templateUrl: './seletor-icone.html',
    styleUrl: './seletor-icone.scss'
})
/** Seletor de ícone PrimeIcons (busca + grade) para o cadastro de serviços do portal. */
export class SeletorIcone {
    /** Visibilidade do modal (two-way). */
    readonly visivel = model<boolean>(false);
    /** Ícone atualmente selecionado (para destaque). */
    readonly selecionado = model<string>('');
    /** Emite a classe do PrimeIcon escolhido (ex.: `pi pi-building`). */
    readonly onSelecionar = output<string>();

    protected readonly busca = signal<string>('');

    /** Todos os ícones do PrimeIcons (`pi pi-...`). */
    private readonly todos: string[] = Object.values(PrimeIcons).filter((valor): valor is string => typeof valor === 'string' && valor.startsWith('pi '));

    protected readonly iconesFiltrados = computed<string[]>(() => {
        const termo = this.busca().trim().toLowerCase();
        if (!termo) {
            return this.todos;
        }
        return this.todos.filter((icone) => icone.toLowerCase().includes(termo));
    });

    /** Nome curto (sem prefixo `pi pi-`) para tooltip/aria. */
    protected nome(icone: string): string {
        return icone.replace('pi pi-', '');
    }

    protected escolher(icone: string): void {
        this.selecionado.set(icone);
        this.onSelecionar.emit(icone);
        this.visivel.set(false);
    }
}
